import type { ComponentType, ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { CCS_PALETTE } from "./theme";

export interface EmptyStateProps {
  icon?: ComponentType<{ sx?: object }>;
  title?: string;
  description?: string;
  action?: ReactNode;
}

/**
 * Minimal-style empty state — centred icon (in a tinted circle), a title,
 * an optional description line, and an optional action slot.
 */
export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <Box
      sx={{
        py: 8,
        px: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: 1.5,
      }}
    >
      {Icon && (
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: `${CCS_PALETTE.katanaPurple}12`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 0.5,
          }}
        >
          <Icon sx={{ fontSize: 28, color: CCS_PALETTE.katanaPurple, opacity: 0.7 }} />
        </Box>
      )}
      {title && (
        <Typography variant="h6" sx={{ fontWeight: 600, color: "text.primary" }}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
          {description}
        </Typography>
      )}
      {action}
    </Box>
  );
}
